import React from "react";
import Preloader from "../../helper/Preloader";
import HeaderOne from "../../components/layout/HeaderOne";
import HeaderHome from "../../components/layout/HeaderHome";
import Breadcrumb from "../../components/Breadcrumb";
import BottomFooter from "../../components/layout/BottomFooter";
import Account from "../../components/account/Account";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../../helper/ColorInit";
import FooterOne from "../../components/layout/FooterOne";

const AccountPage = () => {



  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

      {/* HeaderTwo */}
      {/* <HeaderOne /> */}
      <HeaderHome />

      {/* Breadcrumb */}
      <Breadcrumb title={"My Account"} />

      {/* Account */}
      <Account />

      {/* ShippingOne */}
      {/* <ShippingOne /> */}

      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />


    </>
  );
};

export default AccountPage;
